/*  ==1     DOM READY
****************************************************************************************************/
$(document).ready(function () {
    pluginsInits();
    menuslidetoggleInit($("[data-id='menu-button']"), $("[data-id='mobile-nav']"), $("[data-id='mobile-search']"),
        $("[data-id='search-button']"));
    menuslidetoggleInit($("[data-id='search-button']"), $("[data-id='mobile-search']"), $("[data-id='mobile-nav']"), $("[data-id='menu-button']"));
    //slidetoggleInit($("[data-id='helpform-button']"), $("[data-id='helpform-content']"));
    slidetoggleInit($("[data-id='form-toggle']"), $("[data-id='form-toggle-content']"));
    slidetoggleInit($("[data-id='toggle-button']"), $("[data-id='toggle-content']"));
    placeholderInit();
    loginInit();
    servicenavInit($('[data-id="servicenav-button"]'), $('[data-id="servicenav-content"]'));
    moreservicesInit();
    $(".m-wysiwyg").fitVids();
    dataTables();
    select();
    setTimeout('wizardInit();', 2000);
    radioButton();
    addressFinderInit();
    addressFinderMultipleInit();
    vehicleFinderInit();
    helpForm();
    maptabsInit();
    myTransactions();
    passwordStrength();
    parkingFormsInit();
    p2pdates();
    hashFocus();
    abbrTooltip();
    repairsInit();
    radioButtonRepair();
    repairPicture();
    listShowMore();
    repairCategories();
    repairSingleSubmit();
    cancelForm();
    headerInit();
    makeSquareInit();
    closeButtonInit();
    scrollerInit();
    lightboxPopupInit();
    textStyleControllerInit();
    addAddressInit();
    removeAddressInit();
    fileUploadInit();
    dutyPlanningApt();
    ctaButtonClass();
    selectableGroupInit();
    spinnerInit();
    showOrHideInit();
    initPassword();
    initInvite();
    initUpload();
    cookieInit();
    yourAreaInit();
    newsHeadingInit();
    prefabTitle();
    byServiceFilter();
    updateCludoSearchTitle();
    foiSearch();
    createCanonicalLink();
    externalLinkHandling();     
});




